module.exports = __webpack_public_path__ + "img/fond-troupeau.632a7c6f.jpg";